// src/hooks/useFBRLookup.js

import { supabase } from "../supabaseClient";
import { lookupNTN } from "../utils";

// Custom hook
export function useFBRLookup() {
  return {
    lookupNTN: (raw) => lookupNTN(raw, supabase),
  };
}
